var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.7738 19.0524L16.2545 14.533C17.1883 13.1257 17.7348 11.4406 17.7348 9.62914C17.7348 4.7208 13.7416 0.727539 8.83324 0.727539C3.9249 0.727539 -0.0683594 4.7208 -0.0683594 9.62914C-0.0683594 14.5375 3.9249 18.5307 8.83324 18.5307C10.6447 18.5307 12.3298 17.9842 13.7371 17.0504L18.2565 21.5697C18.9508 22.265 20.0795 22.265 20.7738 21.5697C21.4691 20.8745 21.4691 19.7476 20.7738 19.0524ZM2.60212 9.62914C2.60212 6.19312 5.39722 3.39802 8.83324 3.39802C12.2693 3.39802 15.0644 6.19312 15.0644 9.62914C15.0644 13.0652 12.2693 15.8603 8.83324 15.8603C5.39722 15.8603 2.60212 13.0652 2.60212 9.62914Z",
    fill: "#9199A8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.650bf15652ce6c807b5a7c67ae36b953.svg";
export { ForwardRef as ReactComponent };